import { makeStyles } from 'tss-react/mui';

const useOnStarNavRibbonStyles = makeStyles()(() => ({
  root: {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    padding: '12px 24px',
    minHeight: '40px',
    '&.isOpen': {
      justifyContent: 'flex-start',
      backgroundColor: '#0956FF', // TODO: temporary color and not part of the design systems
    },
  },
  iconWrapper: {
    alignItems: 'center',
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'center',
  },
}));

export default useOnStarNavRibbonStyles;
